import React from 'react';
import { Button } from '../../../../../Utility/Button';

interface ActionButtonsProps {
    executeLabel: string;
    executingLabel: string;
    resetLabel: string;
    canExecute: boolean;
    isLoading: boolean;
    hasResult: boolean;
    onExecute: () => void;
    onReset: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
    executeLabel,
    executingLabel,
    resetLabel,
    canExecute,
    isLoading,
    hasResult,
    onExecute,
    onReset,
}) => {
    return (
        <div className="mt-0 flex items-center gap-3">
            <Button onClick={canExecute ? onExecute : undefined} variant={`${!canExecute ? 'disabled' : 'primary'}`}>
                {isLoading ? executingLabel : executeLabel}
            </Button>
            {hasResult && (
                <Button variant="secondary" onClick={onReset}>
                    {resetLabel}
                </Button>
            )}
        </div>
    );
};

export default ActionButtons;
